// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@keyframes scaleAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
  100% {
    opacity: 1;
  }
}
.advantages {
  display: flex;
  justify-content: center;
}
.advantages .container {
  max-width: 1200px;
  margin-top: 40px;
}
.advantages .container .advantages_title {
  text-align: center;
  color: rgb(49, 49, 49);
  font-family: "Century Gothic";
  font-weight: 300;
  font-size: 2.4rem;
  line-height: 3rem;
}
@media screen and (max-width: 991px) {
  .advantages .container .advantages_title {
    margin: 0 auto;
    max-width: 720px;
  }
}
@media screen and (max-width: 640px) {
  .advantages .container .advantages_title {
    max-width: 580px;
  }
}
@media screen and (max-width: 480px) {
  .advantages .container .advantages_title {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.advantages .container .advantages_text {
  padding: 0 100px;
  text-align: center;
  color: rgb(49, 49, 49);
  font-family: "Roboto-Light";
  font-size: 17px;
}
.advantages .container .items_advantages {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
@media screen and (max-width: 991px) {
  .advantages .container .items_advantages {
    grid-template-columns: repeat(1, 1fr);
  }
}
.advantages .container .items_advantages .item_advantage {
  max-width: 400px;
  height: auto;
  padding: 0 30px;
  margin-bottom: 40px;
}
@media screen and (max-width: 991px) {
  .advantages .container .items_advantages .item_advantage {
    margin: 0 auto 40px auto;
    max-width: 70%;
  }
}
.advantages .container .items_advantages .item_advantage .image_advantage {
  display: flex;
  justify-content: center;
  max-width: 100%;
}
.advantages .container .items_advantages .item_advantage .image_advantage:hover {
  animation: 1s scaleAnimation ease-out;
}
.advantages .container .items_advantages .item_advantage .item_title_advantage {
  color: rgb(49, 49, 49);
  font-family: "Century Gothic";
  font-size: 17px;
  font-weight: 600;
  text-align: center;
}
.advantages .container .items_advantages .item_advantage .text_item_advantage {
  color: rgb(129, 129, 129);
  font-family: "Roboto-Light";
  font-size: 17px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/components/Advantages/Advantages.scss","webpack://./styles/animation.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;ACXA;EACI;IACE,UAAA;EDaJ;ECVE;IACE,UAAA;IACA,qBAAA;EDYJ;ECTE;IACA,mBAAA;EDWF;ECRE;IACE,UAAA;EDUJ;AACF;AAvBA;EACI,aAAA;EACA,uBAAA;AAyBJ;AAvBI;EACI,iBAAA;EACA,gBAAA;AAyBR;AAvBQ;EACI,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAyBZ;AAvBY;EARJ;IASQ,cAAA;IACA,gBAAA;EA0Bd;AACF;AAxBa;EAbL;IAcS,gBAAA;EA2Bf;AACF;AAzBY;EAjBJ;IAkBQ,eAAA;IACA,kBAAA;IACA,kBAAA;EA4Bd;AACF;AAzBQ;EACI,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;AA2BZ;AAxBQ;EACI,aAAA;EACA,qCAAA;AA0BZ;AAvBY;EALJ;IAMQ,qCAAA;EA0Bd;AACF;AAvBY;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAyBhB;AAvBgB;EANJ;IAOQ,wBAAA;IACA,cAAA;EA0BlB;AACF;AAxBgB;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AA0BpB;AAvBgB;EACI,qCAAA;AAyBpB;AAtBgB;EACI,sBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAwBpB;AArBgB;EACI,yBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;AAuBpB","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n@import '../../../styles/animation.scss';\n\n.advantages {\n    display: flex;\n    justify-content: center;\n\n    .container {\n        max-width: 1200px;\n        margin-top: 40px;\n\n        .advantages_title {\n            text-align: center;\n            color: rgb(49, 49, 49);\n            font-family: \"Century Gothic\";\n            font-weight: 300;\n            font-size: 2.4rem;\n            line-height: 3rem;\n\n            @media screen and (max-width: 991px) {\n                margin: 0 auto;\n                max-width: 720px;\n             }\n\n             @media screen and (max-width: 640px) {\n                 max-width: 580px;\n              }\n\n            @media screen and (max-width: 480px) {\n                padding: 0 20px;\n                font-size: 1.56rem;\n                line-height: 1.2em;\n            }\n        }\n\n        .advantages_text {\n            padding: 0 100px;\n            text-align: center;\n            color: rgb(49, 49, 49);\n            font-family: \"Roboto-Light\";\n            font-size: 17px;\n        }\n\n        .items_advantages {\n            display: grid;\n            grid-template-columns: repeat(3, 1fr);\n\n\n            @media screen and (max-width: 991px) {\n                grid-template-columns: repeat(1, 1fr);\n            }\n\n\n            .item_advantage {\n                max-width: 400px;\n                height: auto;\n                padding: 0 30px;\n                margin-bottom: 40px;\n\n                @media screen and (max-width: 991px) {\n                    margin: 0 auto 40px auto;\n                    max-width: 70%;\n                }\n\n                .image_advantage {\n                    display: flex;\n                    justify-content: center;\n                    max-width: 100%;\n                }\n\n                .image_advantage:hover {\n                    animation: 1s scaleAnimation ease-out;\n                }\n\n                .item_title_advantage {\n                    color: rgb(49, 49, 49);\n                    font-family: \"Century Gothic\";\n                    font-size: 17px;\n                    font-weight: 600;\n                    text-align: center\n                }\n\n                .text_item_advantage {\n                    color: rgb(129, 129, 129);\n                    font-family: \"Roboto-Light\";\n                    font-size: 17px;\n                    text-align: center;\n\n                }\n            }\n        }\n\n    }\n}","@keyframes scaleAnimation {\n    0% {\n      opacity: 1;\n    }\n\n    50% {\n      opacity: 0;\n      transform: scale(1.3);\n\n    }\n    70%{\n    transform: scale(1);\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
